export default ["/\\d/", "/\\d/", "/", "/\\d/", "/\\d/", "/", "/\\d/", "/\\d/", "/\\d/", "/\\d/"];